export default "__VITE_ASSET__D4R5AaR1__"